import { useBooleanState } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsOfferPageRedesign } from 'shared/selectors';

import { getOffersHistorySpoiler, setCategoriesFilter, setIsFiltersChanged } from '../../../actions/offersHistory';
import { selectOffersHistorySpoilerData } from '../../../selectors/offersHistory';
import { mapOfferCategoriesEnums } from '../../../store/offerHistory';
import { OfferHistory, OpenFullscreenBtn } from '../components';
import { CategoryTabs } from '../components/CategoryTabs';
import { FeedContainer } from './FeedContainer';
import { FullscreenViewContainer } from './FullscreenViewContainer';
import { trackEntryIntoView } from './analytics';
import { useActiveCategory } from './utils/useActiveCategory';
import { useHandleOfferRowClick } from './utils/useHandleOfferRowClick';
import { useTitle } from './utils/useTitle';

export const OfferHistoryContainer: React.FC = () => {
  const dispatch = useDispatch();
  const fullscreenOpenState = useBooleanState(false);
  const [, openFullscreenView] = fullscreenOpenState;
  const { data: offersHistorySpoilerData, isFetching } = useSelector(selectOffersHistorySpoilerData);
  const isRedesignPage = useSelector(selectIsOfferPageRedesign);

  const title = useTitle();
  const [activeCategory, handleActiveCategoryChange] = useActiveCategory();

  const handleOfferClick = useHandleOfferRowClick(openFullscreenView);

  const handleFullscreenClose = React.useCallback(() => {
    if (offersHistorySpoilerData?.filters?.activeCategory) {
      dispatch(setCategoriesFilter(mapOfferCategoriesEnums[offersHistorySpoilerData.filters.activeCategory]));
    }
  }, [dispatch, offersHistorySpoilerData]);

  React.useEffect(() => {
    if (!offersHistorySpoilerData) {
      dispatch(getOffersHistorySpoiler());
    }

    return () => {
      dispatch(setIsFiltersChanged(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (!offersHistorySpoilerData?.totalCount) {
    return null;
  }

  return (
    <OfferHistory
      title={title}
      tabs={
        offersHistorySpoilerData.filters ? (
          <CategoryTabs
            {...offersHistorySpoilerData.filters}
            activeCategory={activeCategory || offersHistorySpoilerData.filters.activeCategory}
            onTabClick={handleActiveCategoryChange}
          />
        ) : undefined
      }
      offersTableSmall={<FeedContainer onOfferClick={handleOfferClick} isSpoiler />}
      fullscreenViewBtn={
        offersHistorySpoilerData.totalCountText && !isFetching ? (
          <OpenFullscreenBtn
            onClick={handleOfferClick}
            text={offersHistorySpoilerData.totalCountText}
            onView={trackEntryIntoView}
          />
        ) : undefined
      }
      fullscreenView={
        <FullscreenViewContainer fullscreenOpenState={fullscreenOpenState} onClose={handleFullscreenClose} />
      }
      redesign={isRedesignPage}
    />
  );
};
